firebird.factory('videoPlaybackControlsBridge', [
    '$compile',
    '$window',
    'logService',
    function ($compile, $window, logService) {
        var service = {
            mount: mount,
            update: update,
            destroy: destroy
        };

        var logger = logService.createLoggerWithSource('[videoroomCtrl] videoPlaybackControlsBridge');
        var HOST_CLASS_NAME = 'video-playback-controls-host';
        var SCOPE_NAME = 'videoPlaybackControlsVm';

        return service;

        function mount(parentScope, hostDiv, fileVideoElement) {
            if (!parentScope || !hostDiv || !fileVideoElement) {
                logger.warn('mount skipped due to missing input', {
                    hasParentScope: !!parentScope,
                    hasHostDiv: !!hostDiv,
                    hasFileVideoElement: !!fileVideoElement
                });
                return null;
            }

            var childScope = createChildScope(parentScope, hostDiv, fileVideoElement);
            var wrapper = createHostWrapper(hostDiv.ownerDocument || $window.document);
            var element = createControlsElement();

            wrapper.appendChild(element[0]);
            hostDiv.appendChild(wrapper);
            $compile(element)(childScope);

            var stopEventPropagation = installHostEventShielding(wrapper);
            syncScope(childScope);

            return {
                hostDiv: hostDiv,
                wrapper: wrapper,
                element: element,
                scope: childScope,
                stopEventPropagation: stopEventPropagation
            };
        }

        function update(handle, hostDiv, fileVideoElement) {
            if (!handle) {
                logger.warn('update skipped because handle is missing');
                return null;
            }

            if (!hostDiv || !fileVideoElement) {
                logger.warn('update skipped due to missing input', {
                    hasHostDiv: !!hostDiv,
                    hasFileVideoElement: !!fileVideoElement
                });
                return handle;
            }

            handle.hostDiv = hostDiv;
            handle.scope[SCOPE_NAME].fileVideoElement = fileVideoElement;
            handle.scope[SCOPE_NAME].hostElement = hostDiv;

            if (handle.wrapper.parentNode !== hostDiv) {
                hostDiv.appendChild(handle.wrapper);
            }

            syncScope(handle.scope);
            return handle;
        }

        function destroy(handle) {
            if (!handle) {
                return;
            }

            if (handle.scope) {
                handle.scope.$destroy();
            }

            if (handle.wrapper && handle.stopEventPropagation) {
                handle.wrapper.removeEventListener('mousedown', handle.stopEventPropagation);
                handle.wrapper.removeEventListener('mouseup', handle.stopEventPropagation);
                handle.wrapper.removeEventListener('click', handle.stopEventPropagation);
                handle.wrapper.removeEventListener('touchstart', handle.stopEventPropagation);
            }

            if (handle.wrapper && handle.wrapper.parentNode) {
                handle.wrapper.parentNode.removeChild(handle.wrapper);
            }
        }

        function createChildScope(parentScope, hostDiv, fileVideoElement) {
            var childScope = parentScope.$new(true);
            childScope[SCOPE_NAME] = {
                fileVideoElement: fileVideoElement,
                hostElement: hostDiv
            };

            return childScope;
        }

        function createControlsElement() {
            return $window.angular.element(
                '<video-playback-controls ' +
                    '[file-video-element]="' +
                    SCOPE_NAME +
                    '.fileVideoElement" ' +
                    '[host-element]="' +
                    SCOPE_NAME +
                    '.hostElement">' +
                    '</video-playback-controls>'
            );
        }

        function createHostWrapper(documentRef) {
            var wrapper = documentRef.createElement('div');
            wrapper.className = HOST_CLASS_NAME;
            wrapper.setAttribute('data-role', 'video-playback-controls-host');
            applyHostContract(wrapper);
            return wrapper;
        }

        function applyHostContract(wrapper) {
            wrapper.style.position = 'absolute';
            wrapper.style.left = '12px';
            wrapper.style.right = '12px';
            wrapper.style.bottom = '12px';
            wrapper.style.zIndex = '6';
            wrapper.style.display = 'block';
            wrapper.style.pointerEvents = 'auto';
        }

        function installHostEventShielding(wrapper) {
            var stopEventPropagation = function (event) {
                event.stopPropagation();
            };

            wrapper.addEventListener('mousedown', stopEventPropagation);
            wrapper.addEventListener('mouseup', stopEventPropagation);
            wrapper.addEventListener('click', stopEventPropagation);
            wrapper.addEventListener('touchstart', stopEventPropagation, { passive: true });
            return stopEventPropagation;
        }

        function syncScope(scope) {
            if (!scope) {
                return;
            }

            if (!scope.$root.$$phase) {
                scope.$digest();
                return;
            }

            scope.$evalAsync();
        }
    }
]);
